// AUTO-GENERATED by scripts/generate-og-images.tsx — do not edit by hand.
// Run `bun run og` to regenerate. Maps a route path to its OG image.

export const OG_IMAGES: Record<string, string> = {
  "/": "/og/home.png",
  "/about": "/og/about.png",
  "/blog": "/og/blog.png",
  "/case-studies": "/og/case-studies.png",
  "/comparisons": "/og/comparisons.png",
  "/comparisons/axy-vs-airops": "/og/comparisons-axy-vs-airops.png",
  "/comparisons/axy-vs-blaze-ai": "/og/comparisons-axy-vs-blaze-ai.png",
  "/comparisons/axy-vs-clearscope": "/og/comparisons-axy-vs-clearscope.png",
  "/comparisons/axy-vs-coldiq": "/og/comparisons-axy-vs-coldiq.png",
  "/comparisons/axy-vs-copy-ai": "/og/comparisons-axy-vs-copy-ai.png",
  "/comparisons/axy-vs-diy-agents": "/og/comparisons-axy-vs-diy-agents.png",
  "/comparisons/axy-vs-gauge": "/og/comparisons-axy-vs-gauge.png",
  "/comparisons/axy-vs-getdojo-ai": "/og/comparisons-axy-vs-getdojo-ai.png",
  "/comparisons/axy-vs-hubspot": "/og/comparisons-axy-vs-hubspot.png",
  "/comparisons/axy-vs-jasper": "/og/comparisons-axy-vs-jasper.png",
  "/comparisons/axy-vs-sprout-social": "/og/comparisons-axy-vs-sprout-social.png",
  "/comparisons/axy-vs-surfer-seo": "/og/comparisons-axy-vs-surfer-seo.png",
  "/comparisons/axy-vs-taplio": "/og/comparisons-axy-vs-taplio.png",
  "/comparisons/axy-vs-traditional-agency": "/og/comparisons-axy-vs-traditional-agency.png",
  "/comparisons/axy-vs-workflows-io": "/og/comparisons-axy-vs-workflows-io.png",
  "/comparisons/axy-vs-writesonic": "/og/comparisons-axy-vs-writesonic.png",
  "/geo": "/og/geo.png",
  "/geo/create-citation-worthy-content": "/og/geo-create-citation-worthy-content.png",
  "/geo/first-party-and-third-party-citations": "/og/geo-first-party-and-third-party-citations.png",
  "/geo/how-geo-differs-from-traditional-seo": "/og/geo-how-geo-differs-from-traditional-seo.png",
  "/geo/internal-linking-supports-geo-and-seo": "/og/geo-internal-linking-supports-geo-and-seo.png",
  "/geo/measure-whether-geo-content-is-working":
    "/og/geo-measure-whether-geo-content-is-working.png",
  "/geo/prioritize-ai-prompts": "/og/geo-prioritize-ai-prompts.png",
  "/geo/structure-content-for-ai-citations": "/og/geo-structure-content-for-ai-citations.png",
  "/geo/turn-ai-visibility-gaps-into-geo-content":
    "/og/geo-turn-ai-visibility-gaps-into-geo-content.png",
  "/geo/use-competitor-visibility-to-find-content-opportunities":
    "/og/geo-use-competitor-visibility-to-find-content-opportunities.png",
  "/geo/use-prompt-clusters-to-plan-content": "/og/geo-use-prompt-clusters-to-plan-content.png",
  "/geo/what-is-ai-visibility": "/og/geo-what-is-ai-visibility.png",
  "/geo/what-is-citation-rate": "/og/geo-what-is-citation-rate.png",
  "/geo/what-is-geo-aeo-and-seo": "/og/geo-what-is-geo-aeo-and-seo.png",
  "/geo/what-is-mention-rate": "/og/geo-what-is-mention-rate.png",
  "/lp/ai-visibility-founder": "/og/lp-ai-visibility-founder.png",
  "/lp/ai-visibility-marketers": "/og/lp-ai-visibility-marketers.png",
  "/pricing": "/og/pricing.png",
  "/privacy": "/og/privacy.png",
  "/products": "/og/products.png",
  "/products/ai-visibility-analytics": "/og/products-ai-visibility-analytics.png",
  "/products/cross-channel-social-analytics": "/og/products-cross-channel-social-analytics.png",
  "/products/geo-aeo-seo-autopilot": "/og/products-geo-aeo-seo-autopilot.png",
  "/products/linkedin-autopilot": "/og/products-linkedin-autopilot.png",
  "/products/market-intelligence": "/og/products-market-intelligence.png",
  "/products/x-autopilot": "/og/products-x-autopilot.png",
  "/terms": "/og/terms.png",
  "/tutorials": "/og/tutorials.png",
  "/tutorials/add-your-competitors": "/og/tutorials-add-your-competitors.png",
  "/tutorials/create-custom-campaigns": "/og/tutorials-create-custom-campaigns.png",
  "/tutorials/customize-geography-and-language":
    "/og/tutorials-customize-geography-and-language.png",
  "/tutorials/generate-a-geo-article": "/og/tutorials-generate-a-geo-article.png",
  "/tutorials/generate-linkedin-posts": "/og/tutorials-generate-linkedin-posts.png",
  "/tutorials/generate-x-posts-and-threads": "/og/tutorials-generate-x-posts-and-threads.png",
  "/tutorials/how-axy-generates-campaigns": "/og/tutorials-how-axy-generates-campaigns.png",
  "/tutorials/manage-multiple-brands": "/og/tutorials-manage-multiple-brands.png",
  "/tutorials/populate-your-knowledge-base": "/og/tutorials-populate-your-knowledge-base.png",
  "/tutorials/read-market-signals": "/og/tutorials-read-market-signals.png",
  "/tutorials/read-market-trends": "/og/tutorials-read-market-trends.png",
  "/tutorials/read-search-opportunities": "/og/tutorials-read-search-opportunities.png",
  "/tutorials/read-your-ai-visibility-report": "/og/tutorials-read-your-ai-visibility-report.png",
  "/tutorials/read-your-market-intelligence-dashboard":
    "/og/tutorials-read-your-market-intelligence-dashboard.png",
  "/tutorials/repurpose-one-campaign-across-channels":
    "/og/tutorials-repurpose-one-campaign-across-channels.png",
  "/tutorials/review-marketing-strategy-and-channel-plans":
    "/og/tutorials-review-marketing-strategy-and-channel-plans.png",
  "/tutorials/set-up-your-axy-engine": "/og/tutorials-set-up-your-axy-engine.png",
  "/tutorials/turn-client-feedback-into-case-study":
    "/og/tutorials-turn-client-feedback-into-case-study.png",
  "/tutorials/turn-draft-article-or-post-into-campaign":
    "/og/tutorials-turn-draft-article-or-post-into-campaign.png",
  "/tutorials/turn-product-brief-into-launch-campaign":
    "/og/tutorials-turn-product-brief-into-launch-campaign.png",
  "/tutorials/turn-signals-into-campaigns": "/og/tutorials-turn-signals-into-campaigns.png",
  "/tutorials/update-strategy-with-new-resources":
    "/og/tutorials-update-strategy-with-new-resources.png",
  "/tutorials/use-the-marketing-calendar": "/og/tutorials-use-the-marketing-calendar.png",
  "/use-cases": "/og/use-cases.png",
  "/use-cases/agencies-studios": "/og/use-cases-agencies-studios.png",
  "/use-cases/b2b-saas": "/og/use-cases-b2b-saas.png",
  "/use-cases/cybersecurity": "/og/use-cases-cybersecurity.png",
  "/use-cases/ecommerce": "/og/use-cases-ecommerce.png",
  "/use-cases/fitness": "/og/use-cases-fitness.png",
  "/use-cases/high-growth-startups": "/og/use-cases-high-growth-startups.png",
  "/use-cases/law": "/og/use-cases-law.png",
  "/use-cases/logistics": "/og/use-cases-logistics.png",
  "/use-cases/mid-market-enterprise": "/og/use-cases-mid-market-enterprise.png",
  "/use-cases/real-estate-construction": "/og/use-cases-real-estate-construction.png",
  "/use-cases/venture-studios": "/og/use-cases-venture-studios.png",
  "/use-cases/web3": "/og/use-cases-web3.png",
};
